import { render, staticRenderFns } from "./EditProductNew.vue?vue&type=template&id=c5af7522&scoped=true&"
import script from "./EditProductNew.vue?vue&type=script&lang=js&"
export * from "./EditProductNew.vue?vue&type=script&lang=js&"
import style0 from "./EditProductNew.vue?vue&type=style&index=0&id=c5af7522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5af7522",
  null
  
)

export default component.exports